import YandexBlock from './YandexBlock';

export default YandexBlock;
